import { create } from 'zustand'
import client from '../api/client'

interface TokenState {
  balance: number
  starsBalance: number
  totalUsed: number
  isLoading: boolean
  storedFromCache: boolean
  fetchBalance: () => Promise<void>
  purchaseTokens: (amount: number) => Promise<void>
}

// Кэш в localStorage для мгновенного восстановления при Ctrl+Shift+R
const CACHE_KEY = 'cached_balance'
function loadCache() {
  try {
    const raw = localStorage.getItem(CACHE_KEY)
    if (raw) return JSON.parse(raw)
  } catch {}
  return null
}
function saveCache(data: { balance: number; starsBalance: number; totalUsed: number }) {
  try {
    localStorage.setItem(CACHE_KEY, JSON.stringify(data))
  } catch {}
}

const cached = loadCache()

export const useTokenStore = create<TokenState>((set) => ({
  balance: cached?.balance ?? 0,
  starsBalance: cached?.starsBalance ?? 0,
  totalUsed: cached?.totalUsed ?? 0,
  isLoading: false,
  storedFromCache: !!cached,

  fetchBalance: async () => {
    set({ isLoading: true, storedFromCache: false })
    try {
      const { data } = await client.get('/tokens/balance')
      const fresh = { balance: data.balance, starsBalance: data.stars_balance ?? 0, totalUsed: data.total_used ?? 0 }
      saveCache(fresh)
      set({ ...fresh, isLoading: false, storedFromCache: false })
    } catch {
      // Если запрос упал, но есть кэш — оставляем его
      const localCache = loadCache()
      if (localCache) {
        set({ ...localCache, isLoading: false, storedFromCache: true })
      } else {
        set({ isLoading: false, storedFromCache: false })
      }
    }
  },

  purchaseTokens: async (amount: number) => {
    const { data } = await client.post('/tokens/purchase', { amount })
    set((state) => ({ balance: state.balance + data.amount }))
  },
}))
